module.exports = __webpack_public_path__ + "img/3.79d3b3f2.svg";